module.exports = __webpack_public_path__ + "img/loreto.0b66fd4f.png";